(function($) {
	'use strict';

	let init = function() {
		manageToggleBtn();
        selects();
	};

	let manageToggleBtn = function ()
    {
		$('.toggle-btn').on('click', function() {
			$(this).find('button').toggleClass('open');
			$(this).closest('.toggle-parent').toggleClass('open');
			$(this).find('button')[0].setAttribute('aria-expanded', $(this).find('button').hasClass('open'));
		});
	};

    let selects = function ()
    {

        if (document.getElementById('depart'))
        {
            initSelect( document.getElementById('depart') );
            initSelect( document.getElementById('arrivee') );
        }
    }

    let initSelect = function (select)
    {
        const config = {
            searchResultLimit: 10, // Nombre de résultats à afficher dans la liste après une recherche
            maxItemCount: 1,       // Nombre max d'items autorisés
            itemSelectText: '',    // Texte affiché à droite lors de la sélection d'un item
            position: 'bottom',

            callbackOnCreateTemplates: () => ({
                input: (...args) =>
                    Object.assign(Choices.defaults.templates.input.call(this, ...args), {
                        type: 'text',
                        role: 'combobox',
                        ariaLabel: null,
                        id: 'input-' +  select.id
                    }),
            }),
        };

        select.choice = new Choices(select, config);

        // Si le champ est déjà rempli (lors de l'édition), ajouter la classe le précisant
        if (select.value != "")
        {
            select.choice.containerInner.element.classList.add('filled');
        }

        /**********************
         *     Fonctions      *
         **********************/

        // Ajoute une fonction permettant d'afficher/cacher l'élément
        select.choice.show = function(show = true)
        {
            const formField = this.containerOuter.element.parentNode;

            formField.style.display = (show)
                ? 'block'
                : 'none';

            if (!show) {
                this.removeActiveItems();
                this.containerInner.element.classList.remove('filled');
            }
        }

        /**********************
         *       Events       *
         **********************/

        // Ajoute une classe CSS lorsque que la liste de sélection est remplie
        select.choice.passedElement.element.addEventListener('change', function ()
            {
                this.parentNode.classList.toggle('filled', this.nextSibling.childNodes.length > 0);
            }
        );

        // Désélectionne l'input lorsqu'un item a été ajouté à la liste
        select.choice.passedElement.element.addEventListener('addItem', function ()
            {
                this.choice.input.element.blur();
            }
        );

        // Efface la sélection lorsque l'input est sélectionné
        select.choice.input.element.addEventListener('focus', function ()
            {
                select.choice.removeActiveItems();
                select.choice.containerInner.element.classList.remove('filled');
            }
        );    
    }

	$(document).ready(function() {
		init();
	});

})(jQuery);
